<template>
  <div>
    <tr v-if="talle.length !== 0">
      <td class="tabla_venta_producto padding_left talle_nombre">{{ talle.talle_nombre }}</td>
      <td class="tabla_venta_cantidad">{{ talle.cantidad }}</td>
      <td class="tabla_venta_monto">${{ dotsCadaTres(parseFloat(talle.precio_total).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ talle.cantidad_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(talle.facturado_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ talle.cantidad_no_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(talle.facturado_no_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
    </tr>
    <div v-if="talle.length !== 0">
      <ProductoListaItemTalleColor
        v-for="color in colores"
        :color="color"
        :key="color.color_id"
      ></ProductoListaItemTalleColor>
    </div>
  </div>
</template>

<script>
import ProductoListaItemTalleColor from '../components/ProductoListaItemTalleColor.vue'
export default {
  name: 'ProductoListaItemTalle',
  components: {
    ProductoListaItemTalleColor
  },
  props: ['talle'],
  data: function () {
    return {
      colores: this.talle.colores
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>
